export default "__VITE_ASSET__5c324853__"